<template>

<div id="slide01" class="section section-dark">

  <div id="slide01-text" class="half-block half-block-1">

    <Title :text="$t('home.slide01.title')"/>

    <Common :text="$t('home.slide01.text')"/>

    <div class="link">

      <Link :text="$t('home.slide01.link')" href="#slide08"/>

    </div>

    <SocialBlock size="2x"/>

  </div>

  <div id="slide01-image" class="half-block half-block-2">
    <Qimage name="analytics.png"/>
  </div>

</div>

</template>

<script>
import Title from '../general/texts/Title.vue'
import Common from '../general/texts/Common.vue'
import Link from '../general/texts/Link.vue'
import SocialBlock from '../general/social/SocialBlock.vue'
import Qimage from '../general/elements/Qimage.vue'

export default {
  name: 'Slide01',
  components: {
    Title,
    Common,
    Link,
    SocialBlock,
    Qimage
  }
}
</script>

<style lang="scss" scoped>
.section {
  width: 100%;
  padding: 0;
  position: relative;

  .half-block-1 {
    width: 35%;
    padding: 100px 0 100px 15%;
    margin: 10px 0;

    div {
      margin: 20px 0;
    }

    .link {
      font-size: 24px;
      font-family: 'Poppins-ExtraBold';
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  .half-block-2 {
    position: absolute;
    right: 0;
    bottom: 0;

    img {
      width: 45%;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}

::v-deep svg {
  padding: 20px 0;
  padding-right: 50px !important;
}

@media (max-width: 2300px), (max-device-width: 2300px) {
  .section {
    .half-block-2 {
      img {
        width: 50%;
      }
    }
  }
}

@media (max-width: 1900px), (max-device-width: 1900px) {
  .section {
    .half-block-2 {
      img {
        width: 60%;
      }
    }
  }
}

@media (max-width: 1700px), (max-device-width: 1700px) {
  .section {
    .half-block-2 {
      img {
        width: 70%;
      }
    }
  }
}

@media (max-width: 1400px), (max-device-width: 1400px) {
  .section {
    .half-block-2 {
      img {
        width: 100%;
      }
    }
  }
}

@media (max-width: 750px), (max-device-width: 750px) {
  .section {
    width: 80%;
    padding: 50px 10% 100px 10%;

    .half-block-1 {
      width:100% !important;
      padding: 0 !important;
      position: relative;
      top: 0;
      left: 0;
      z-index: 1;

      div {
        margin: 40px 0;
      }
    }

    .half-block-2 {
      width: 50%;
      margin: 0;
      opacity: 0.5;
    }
  }
}

@media (max-width: 600px), (max-device-width: 600px) {
  .section {
    .half-block-2 {
      width: 75%;
    }
  }
}

@media (max-width: 450px), (max-device-width: 450px) {
  .section {
    .half-block-2 {
      width: 100%;
    }
  }
}
</style>
